import { Intro } from "components/commons";
import { useMount } from "hooks";
import React from "react";

const IndexModule = () => {
  useMount(() => {});

  return (
    <div>
      <div>
        <Intro
          title={"Index"}
          subtitle={
            "Retrieving and searching digitized copies of documents through a scanning process"
          }
        />
      </div>
    </div>
  );
};

export default IndexModule;
